import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class EncodeHelper {
  private textEncoder = new TextEncoder();

  async getSigningKey(): Promise<CryptoKey> {
    return crypto.subtle.importKey(
      'raw',
      this.textEncoder.encode(environment.PDF_VIEW_TOKEN),
      { name: 'HMAC', hash: 'SHA-256' },
      false,
      ['sign', 'verify']
    );
  }

  base64UrlEncode(str: string): string {
    const base64 = btoa(str);
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  }

  base64UrlDecode(str: string): string {
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) {
      str += '=';
    }
    return atob(str);
  }

  bufferToBase64Url(buffer: ArrayBuffer): string {
    const str = String.fromCharCode(...new Uint8Array(buffer));
    return this.base64UrlEncode(str);
  }

  base64UrlToBuffer(str: string): ArrayBuffer {
    const binaryString = this.base64UrlDecode(str);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  getVerificationKey = async (): Promise<CryptoKey> => {
    return crypto.subtle.importKey(
      'raw',
      this.textEncoder.encode(environment.PDF_VIEW_TOKEN),
      { name: 'HMAC', hash: 'SHA-256' },
      false,
      ['verify']
    );
  };

  encode = (data: string) => {
    return this.textEncoder.encode(data);
  };
}
